import { Services, regExp } from '@sigma-frontend-libs/commons'

import { components, labelModes } from '@/utils'

import generatorRow from '@/components/generator/row'
import rulesTemplate from '@/components/rules/template'
import { ruleTags, ruleTypes } from '@/components/rules/utils'
import routesFormLink from '@/components/services/routes/form/link'
import routesFormTitle from '@/components/services/routes/form/title'
import routesFormType from '@/components/services/routes/form/type'

function renderTypeField(h) {
  if (!this.type) {
    return h(
      routesFormType,
      {
        props: {
          value: this.proxy,
          serviceName: Services.routingRules
        },
        on: {
          input: event => {
            this.proxy = event
          }
        }
      }
    )
  }
}

function renderTitleField(h) {
  return h(
    routesFormTitle,
    {
      props: {
        value: this.proxy,
        disabled: this.disabled,
        serviceName: Services.routingRules
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderRulesGenerator(h) {
  return h(
    rulesTemplate,
    {
      props: {
        value: this.proxy.rules,
        type: this.proxy.type,
        blacklist: [ ruleTags.type, ruleTags.group ],
        ruleType: ruleTypes.conditions
      },
      on: {
        input: event => {
          this.proxy.rules = event
        }
      }
    }
  )
}

function renderProviderGroupField(h, item) {
  if (item.title) {
    return h(
      'div',
      {
        class: `${Services.routingRules}-form-provider-group-draft`
      },
      [
        h(
          'div',
          {
            class: `${Services.routingRules}-form-provider-group-draft-title`
          },
          [ item.title ]
        ),

        h(
          'div',
          {
            class: `${Services.routingRules}-form-provider-group-draft-hint`
          },
          [ this.getTranslate(`${Services.routingRules}.hints.willBeCreated`) ]
        )
      ]
    )
  }

  return h(
    components.select,
    {
      props: {
        value: item.id,
        label: this.getTranslate(`${Services.routingRules}.labels.providerGroup`),
        query: {
          type: this.proxy.type,
          isActive: true
        },
        itemsDisabled: this.proxy.ProviderGroups.map(({ id }) => {
          return id
        }),
        disabled: this.disabled,
        service: Services.providerGroups,
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true,
        autocomplete: true,
        hideSelections: true
      },
      on: {
        input: event => {
          item.id = event
        }
      }
    }
  )
}
function renderPercentageField(h, item) {
  return h(
    components['text-field'],
    {
      props: {
        value: item.percentage,
        label: this.getTranslate(`${Services.routingRules}.labels.percentage`),
        disabled: this.disabled,
        labelMode: labelModes.hidden,
        dense: true,
        required: true,
        details: false,
        mask: regExp.percentage
      },
      on: {
        input: event => {
          item.percentage = event
        }
      }
    }
  )
}
function renderLink(h, item) {
  return h(
    routesFormLink,
    {
      props: {
        value: item,
        service: Services.providerGroups
      }
    }
  )
}
function renderProviderGroup(h, item) {
  return h(
    'div',
    {
      class: `${Services.routingRules}-form-provider-group`
    },
    [
      renderProviderGroupField.call(this, h, item),
      renderPercentageField.call(this, h, item),
      renderLink.call(this, h, item)
    ]
  )
}
function renderProviderGroups(h) {
  if (Array.isArray(this.proxy.ProviderGroups)) {
    return h(
      components.card,
      {
        class: `${Services.routingRules}-form-provider-groups`,
        props: {
          title: this.getTranslate(`${Services.routingRules}.subtitles.${Services.providerGroups}`),
          dashed: true,
          outline: true,
          rounded: true
        }
      },
      [
        h(
          generatorRow,
          {
            props: {
              value: this.proxy.ProviderGroups,
              disabled: this.disabled,
              defaultValue: {
                id: undefined,
                percentage: 100
              }
            },
            on: {
              input: event => {
                this.proxy.ProviderGroups = event
              }
            },
            scopedSlots: {
              row: ({ item }) => {
                return renderProviderGroup.call(this, h, item)
              }
            }
          }
        )
      ]
    )
  }
}

export default function(h) {
  return h(
    components.form,
    {
      class: `${Services.routingRules}-form`
    },
    [
      renderTypeField.call(this, h),
      renderTitleField.call(this, h),
      renderRulesGenerator.call(this, h),
      renderProviderGroups.call(this, h)
    ]
  )
}
